// extracted by mini-css-extract-plugin
module.exports = {"actionModalTitle":"ModalHeader_actionModalTitle__7iKDe","actionModalDescription":"ModalHeader_actionModalDescription__DI3sa"};